import React, { Component } from "react";
import PageDataNumber from './PageDataNumber';

export default class PageData extends Component {
  	
	render () {
		
		let block 		= this.props.block;
		
		if (block) {
		
		    return (
			    
			    <div data-id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after + ' c-page__block--' + block.rule_after}>
			    
			    	<div className="l-content l-content--fixed-width">
			    		
			    		<div className="l-grid">
			    		
			    			<div className="c-data l-grid__col l-grid__col--m-6-12">

			    				{block.left_data && block.left_label &&
			    					<div className="c-data__block">
			    						<PageDataNumber prepend={block.left_data_prepend} data={block.left_data} append={block.left_data_append}></PageDataNumber>
			    						<p className="c-data__label" dangerouslySetInnerHTML={{__html: block.left_label}}></p>
			    					</div>
			    				}
			    							    				
			    			</div>
			    		
			    			<div className="c-data l-grid__col l-grid__col--m-6-12">
			    						    			
								{block.right_data && block.right_label &&
			    					<div className="c-data__block">
			    						<PageDataNumber prepend={block.right_data_prepend} data={block.right_data} append={block.right_data_append}></PageDataNumber>
			    						<p className="c-data__label" dangerouslySetInnerHTML={{__html: block.right_label}}></p>
			    					</div>
			    				}
								
							</div>
			    			
			    		</div>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
